// date range types
export const APPEND_DATE_RANGE = "appendDaterange";

// mutation types
export const SET_DATE_RANGE = "setDaterange";
export const SET_DATE_RANGE_VALUE = "setDaterangeValue";
export const CLEAR_DATE_RANGE = "clearDaterange";
export const CLEAR_DATE_RANGE_VALUE = "clearDaterangeValue";

export default {
  state: {
    dateRanges: [],
    dateRangesValue: []
  },
  getters: {
    /**
     * Get list of dateRanges for current page
     * @param state
     * @returns {*}
     */
    dateRanges(state) {
      return state.dateRanges;
    },

    dateRangesValue(state) {
      return state.dateRangesValue;
    }
  },
  actions: {
    /**
     * Set the dateRanges list
     * @param state
     * @param payload
     */
    [SET_DATE_RANGE](state, payload) {
      state.commit(SET_DATE_RANGE, payload);
    },

    [SET_DATE_RANGE_VALUE](state, payload) {
      state.commit(SET_DATE_RANGE_VALUE, payload);
    },

    [CLEAR_DATE_RANGE](state) {
      state.commit(CLEAR_DATE_RANGE);
    },

    [CLEAR_DATE_RANGE_VALUE](state) {
      state.commit(CLEAR_DATE_RANGE_VALUE);
    }
  },
  mutations: {
    [APPEND_DATE_RANGE](state, payload) {
      state.dateRanges = [...state.dateRanges, payload];
    },
    [SET_DATE_RANGE](state, payload) {
      state.dateRanges = payload;
    },
    [SET_DATE_RANGE_VALUE](state, payload) {
      state.dateRangesValue = payload;
    },
    [CLEAR_DATE_RANGE](state) {
      state.dateRanges = [];
      state.dateRangesValue = [];
    },
    [CLEAR_DATE_RANGE_VALUE](state) {
      state.dateRangesValue = [];
    }
  }
};
